import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_CONTENT_VALIDATION } from 'src/graphql/schema';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateSavedVariationContentValidationArgs,
  BackendSavedVariation,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateSavedVariationContentValidation($id: ID!) {
    updateSavedVariationContentValidation(id: $id) {
      id
      contentSafety {
        ...ContentValidation
      }
      engagementScoreSupportSize
    }
  }
  ${FRAGMENT_CONTENT_VALIDATION}
`;

type Variables = BackendMutationUpdateSavedVariationContentValidationArgs;
type Result = Pick<BackendSavedVariation, 'id' | 'contentSafety' | 'engagementScoreSupportSize'>;

export const updateSavedVariationContentValidation = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
